import { render, staticRenderFns } from "./ReturnAuthorisations.vue?vue&type=template&id=6fa1a2ba&"
import script from "./return-authorisations.js?vue&type=script&lang=js&"
export * from "./return-authorisations.js?vue&type=script&lang=js&"
import style0 from "./return-authorisations.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnAuthorisations.vue"
export default component.exports